import { IntakeLabelCollection } from '../../entities/intake-label.interface';
export const AishTrusteeLabels: IntakeLabelCollection = {
  firstName: {
    label: 'Trustee/Attorney First name',
  },
  lastName: {
    label: 'Trustee/Attorney Last name',
  },
};
